<template>
  <div class="content">
    
    <div class="title"></div>

    <div class="box1">
      <img
        :src="!state.hasReceive ? btn11 : btn22"
        class="btn1"
        @click="onBtnClick"
        @mousedown="isPressed = true"
        @touchstart="isPressed = true"
        @mouseup="isPressed = false"
        @mouseleave="isPressed = false"
        @touchend="isPressed = false"
        :class="{ pressed: isPressed }"
      >
    </div>

    <div class="rule"></div>
    
  </div>
</template>
<script setup>
import { onMounted, reactive, ref } from "vue";
import { getQueryString } from "@/utils/location";
import { setToken } from "@/utils/auth";
import { checkS11Status, getS11Coupon } from "../../../api/activity";
import { Toast } from "vant";

import btn11 from "../../../assets/webActivity/s11/btn1.png";
import btn22 from "../../../assets/webActivity/s11/btn2.png";

const state = reactive({
  uid: "",
  hasReceive: false,
  isClick: false,
});
const isPressed = ref(false);

onMounted(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  state.uid = getQueryString("uid");
  checkStatus()
});
const onBtnClick = ()=>{

  if(state.isClick){
    return
  }
  state.isClick = true
  getS11Coupon({token: getQueryString("token")}).then(res=>{
    Toast(res.data.msg)
    if(res.data.code == 1){
      checkStatus()
    }
  }).finally(()=>{
    state.isClick = false
  })
}

const checkStatus = (()=>{
  checkS11Status({token: getQueryString("token")}).then(res=>{
    if(res.data.code == 1){
      if(res.data.data.isReceive){
        state.hasReceive = true
      }else{
        state.hasReceive = false
      }
    }else{
      state.hasReceive = false
    }
  })
})

</script>

<style src="../../../styles/removeVantcell.css"></style>
<style scoped>
.content {
  height: 100vh;
  overflow: auto;
  /* background-image: url('../../../assets/webActivity/s11/bg1.png');
  background-repeat: no-repeat;
  background-size: 100% auto; */
  background-color: #FDE1D0;
}
.title {
  height: 686px;
  background-image: url('../../../assets/webActivity/s11/bg1.png');
  background-size: 100% 100%;
}
.box1 {
  height: 100px;
  margin: -288px 30px 0;
  height: 568px;
  background-image: url('../../../assets/webActivity/s11/bg2.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: end;
}
.box1 img.btn1 {
  width: 590px;
  height: 124px;
  margin-bottom: 86px;
  transition: transform 0.16s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  user-select: none;
  /* 按钮常规状态下可加一点弹性效果 */
  will-change: transform;
}
.box1 img.btn1.pressed {
  transform: scale(0.92);
}
.rule {
  height: 886px;
  margin: 32px 30px 80px;
  background-image: url('../../../assets/webActivity/s11/bg3.png');
  background-size: 100% 100%;
}
</style>
